export default {
  // Basic info
  'agents.title': 'Agentes',
  'agents.tab.ai': 'IA',
  'agents.tab.rpa': 'RPA',

  // AI Provider options (for filters and forms)
  'agents.ai.provider.openai': 'OpenAI',

  // RPA Platform options (for filters and forms)
  'agents.rpa.platform.windows': 'Windows',
  'agents.rpa.platform.android': 'Android',

  // RPA Status options (for filters and forms)
  'agents.rpa.status.unknown': 'Desconocido',
  'agents.rpa.status.online': 'En Línea',
  'agents.rpa.status.offline': 'Desconectado',
  'agents.rpa.status.disabled': 'Deshabilitado',

  // Buttons
  'agents.button.interact': 'Interactuar',

  'agents.text.ownerUser': 'Propietario',

  // Form field translations
  'agents.form.provider': 'Proveedor',
  'agents.form.publisher': 'Publicado por',
  'agents.form.model': 'Modelo',
  'agents.form.connections': 'Conexiones',
  'agents.form.connections.connection': 'Conexión',
  'agents.form.allowedRoles': 'Configuración de Roles',
  'agents.form.allowedRoles.allowed': 'Roles Permitidos',
  'agents.form.allowedRoles.denied': 'Roles Denegados',
  'agents.form.memory': 'Memoria',
  'agents.form.platform': 'Plataforma',
  'agents.form.name': 'Nombre',
  'agents.form.email': 'Correo Electrónico',
  'agents.form.username': 'Usuario',
  'agents.form.domains': 'Dominios',
  'agents.form.description': 'Descripción',
  'agents.form.longDescription': 'Descripción Larga',
  'agents.form.instructions': 'Instrucciones',
  'agents.form.instructions.edit': 'Editar Instrucciones',
  'agents.form.instructions.placeholder.expanded':
    'Escriba las instrucciones detalladas para su agente de IA...',
  'agents.form.icon': 'Icono',
  'agents.form.isActive': 'Activo',
  'agents.form.status': 'Estado',
  'agents.form.deviceName': 'Nombre del Dispositivo',
  'agents.form.ip': 'Dirección IP',
  'agents.form.ip.error': 'Por favor ingrese una dirección IP válida',

  // Configuration translations
  'agents.form.configurations.greetings': 'Saludos',
  'agents.form.configurations.greetings.message': 'Mensaje',
  'agents.form.configurations.greetings.message.edit': 'Editar Mensaje de Saludo',
  'agents.form.configurations.greetings.message.placeholder':
    'Escriba el mensaje de saludo para este idioma...',
  'agents.form.configurations.searchingHumanAgentMessages': 'Mensajes de Búsqueda de Agente Humano',
  'agents.form.configurations.searchingHumanAgentMessages.message': 'Mensaje',
  'agents.form.configurations.searchingHumanAgentMessages.message.edit':
    'Editar Mensaje de Búsqueda',
  'agents.form.configurations.searchingHumanAgentMessages.message.placeholder':
    'Escriba el mensaje de búsqueda de agente humano para este idioma...',
  'agents.form.configurations.trainingVectors': 'Vectores de Entrenamiento',
  'agents.form.configurations.reasoningEffort': 'Esfuerzo de Razonamiento',
  'agents.form.configurations.reasoningEffort.minimal': 'Mínimo',
  'agents.form.configurations.reasoningEffort.low': 'Bajo',
  'agents.form.configurations.reasoningEffort.medium': 'Medio',
  'agents.form.configurations.reasoningEffort.highcompleted': 'Alto',
  'agents.form.configurations.reasoningSummary': 'Resumen de Razonamiento',
  'agents.form.configurations.reasoningSummary.concise': 'Conciso',
  'agents.form.configurations.reasoningSummary.detailed': 'Detallado',
  'agents.form.configurations.reasoningSummary.auto': 'Automático',
  'agents.form.configurations.allowedTools': 'Herramientas Permitidas',
  'agents.form.configurations.allowedTools.codeinterpreter': 'Intérprete de Código',
  'agents.form.configurations.allowedTools.filesearch': 'Búsqueda de Archivos',
  'agents.form.configurations.allowedTools.websearch': 'Búsqueda Web',
  'agents.form.configurations.allowedTools.imagegeneration': 'Generación de Imágenes',
  'agents.form.configurations.allowedTools.mcp': 'MCP',
  'agents.form.configurations.guardrails.title': 'Barreras de Seguridad',
  'agents.form.configurations.guardrails.moderation.enabled': 'Opciones de Moderación Habilitadas',
  'agents.form.configurations.guardrails.pii.enabled': 'Opciones de PII Habilitadas',
  'agents.form.configurations.guardrails.pii.rules': 'Reglas de PII',
  'agents.form.configurations.guardrails.pii.rules.entity': 'Entidad',
  'agents.form.configurations.guardrails.pii.rules.entity.creditcard': 'Tarjeta de Crédito',
  'agents.form.configurations.guardrails.pii.rules.entity.email': 'Correo Electrónico',
  'agents.form.configurations.guardrails.pii.rules.entity.phone': 'Teléfono',
  'agents.form.configurations.guardrails.pii.rules.entity.ipaddress': 'Dirección IP',
  'agents.form.configurations.guardrails.pii.rules.entity.ibancode': 'Código IBAN',
  'agents.form.configurations.guardrails.pii.rules.entity.url': 'URL',
  'agents.form.configurations.guardrails.pii.rules.entity.usbanknumber': 'Número de Banco US',
  'agents.form.configurations.guardrails.pii.rules.entity.usitin': 'ITIN US',
  'agents.form.configurations.guardrails.pii.rules.entity.uspassport': 'Pasaporte US',
  'agents.form.configurations.guardrails.pii.rules.entity.usssn': 'SSN US',
  'agents.form.configurations.guardrails.pii.rules.entity.pedni': 'DNI PE',
  'agents.form.configurations.guardrails.pii.rules.entity.peruc': 'RUC PE',
  'agents.form.configurations.guardrails.pii.rules.entity.pepassport': 'Pasaporte PE',
  'agents.form.configurations.guardrails.pii.rules.entity.pebankaccountnumber':
    'Número de Cuenta Bancaria PE',
  'agents.form.configurations.guardrails.pii.rules.entity.pebankaccountcci':
    'CCI Cuenta Bancaria PE',
  'agents.form.configurations.guardrails.pii.rules.action': 'Acción',
  'agents.form.configurations.guardrails.pii.rules.action.mask': 'Enmascarar',
  'agents.form.configurations.guardrails.pii.rules.action.pseudonymize': 'Pseudonimizar',
  'agents.form.configurations.guardrails.pii.rules.action.tokenizereversible':
    'Tokenizar Reversible',
  'agents.form.configurations.guardrails.pii.rules.action.remove': 'Eliminar',
  'agents.form.configurations.guardrails.pii.rules.action.keep': 'Mantener',
  'agents.form.configurations.guardrails.pii.rules.maskChar': 'Carácter de máscara',
  'agents.form.configurations.guardrails.pii.rules.keepPrefix': 'Conservar prefijo',
  'agents.form.configurations.guardrails.pii.rules.keepSuffix': 'Conservar sufijo',
  'agents.form.configurations.guardrails.urlFilter.enabled':
    'Opciones de Filtro de URL Habilitadas',
  'agents.form.configurations.guardrails.urlFilter.action': 'Acción',
  'agents.form.configurations.guardrails.urlFilter.action.block': 'Bloquear',
  'agents.form.configurations.guardrails.urlFilter.action.mask': 'Enmascarar',
  'agents.form.configurations.guardrails.urlFilter.action.warn': 'Advertir',
  'agents.form.configurations.guardrails.urlFilter.mode': 'Modo',
  'agents.form.configurations.guardrails.urlFilter.mode.allowlist': 'Lista de Permitidos',
  'agents.form.configurations.guardrails.urlFilter.mode.denylist': 'Lista de Bloqueados',
  'agents.form.configurations.guardrails.urlFilter.allowedDomains': 'Dominios Permitidos',
  'agents.form.configurations.guardrails.urlFilter.blockedDomains': 'Dominios Bloqueados',
  'agents.form.configurations.guardrails.urlFilter.blockedRegex': 'Patrones Bloqueados (Regex)',
  'agents.form.configurations.guardrails.urlFilter.domain': 'Dominio',
  'agents.form.configurations.guardrails.urlFilter.pattern': 'Patrón',
  'agents.form.configurations.guardrails.urlFilter.allowIpHosts': 'Permitir Hosts IP',
  'agents.form.configurations.guardrails.urlFilter.allowedSchemes': 'Esquemas Permitidos',
  'agents.form.configurations.guardrails.urlFilter.scheme': 'Esquema',
  'agents.form.configurations.guardrails.urlFilter.maxUrls': 'Máximo de URLs',
  'agents.form.configurations.guardrails.urlFilter.blockUrlShorteners':
    'Bloquear Acortadores de URL',
  'agents.form.configurations.guardrails.urlFilter.urlShortenerDomains': 'Dominios de Acortadores',
  'agents.form.configurations.guardrails.jailbreak.enabled': 'Opciones de Jailbreak Habilitadas',
  'agents.form.configurations.guardrails.jailbreak.model': 'Modelo',
  'agents.form.configurations.guardrails.jailbreak.blockConfidence': 'Umbral de Bloqueo',

  // Tabs
  'agents.tabs.general': 'General',
  'agents.tabs.configurations': 'Configuraciones',

  // Wizard steps
  'agents.wizard.steps.basicInformation': 'Información Básica',
  'agents.wizard.steps.technicalConfiguration': 'Configuración Técnica',
  'agents.wizard.steps.permissionsAndContent': 'Permisos y Contenido',
  'agents.wizard.steps.advancedConfigurationAndContent': 'Configuración Avanzada y Contenido',
  'agents.wizard.steps.guardrails': 'Guardrails',

  // Global translations
  'global.text.configuration': 'Configuración',
};
